import { render, staticRenderFns } from "./AnswersChat.vue?vue&type=template&id=346ef1ce&scoped=true&"
import script from "./AnswersChat.vue?vue&type=script&lang=js&"
export * from "./AnswersChat.vue?vue&type=script&lang=js&"
import style0 from "./AnswersChat.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AnswersChat.vue?vue&type=style&index=1&id=346ef1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ef1ce",
  null
  
)

export default component.exports